export enum CARD_COLORS {
  PINK = 'pink',
  BLUE = 'blue',
  GREEN = 'green',
  GRAY = 'gray',
  YELLOW = 'yellow',
  ORANGE = 'orange'
}